import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './FormFieldInfos.scss';
/**
 * @component FormFieldInfos
 * @since 1.0.0
 */
export function FormFieldInfos(props) {
    const { size, style, infos } = Object.assign({ style: 'normal' }, props);
    if (infos == null || infos == '') {
        return null;
    }
    const className = classNames('form-field-infos', 'form-field-infos--' + size, 'form-field-infos--' + style, props.className);
    return React.createElement("div", { className: className }, infos);
}
